import axios from "../../../axios";

//Harshada Bhavsar (22/11/2025)
export const getProjectTypes = async () => {
  return axios.get("/api/MetaData/projecttypes");
};

//Harshada Bhavsar (26/11/2025)
export const getRoleTypes = async () => {
  return axios.get("/api/MetaData/roletypes");
};

//Harshada Bhavsar (21/04/2026)
export const getProjectStatus = async () => {
  return axios.get("/api/MetaData/projectstatus");
};


//Harshada Bhavsar (21/04/2026)
export const getTechStack = async () => {
  return axios.get("/api/MetaData/techstack");
};